import { EPGEvents } from "@nrk/player-tracker";
import { ReactiveState } from "@nrk/reactive-element";
import { getLogger } from "../utils/logging";
import { toError } from "@nrk/player-core/utils";
class EPGState extends ReactiveState {
  events;
  _logger = getLogger("EPGState");
  constructor(player) {
    super();
    const { activeSession, psapiClient } = player;
    if (!activeSession) {
      throw new Error("EPGState needs player.activeSession to exist.");
    }
    if (!psapiClient) {
      throw new Error("EPGState needs player.psapiClient to exist.");
    }
    this.events = new EPGEvents(activeSession);
    this.updateEPGLoop(psapiClient).catch((err) => {
      this._logger.warn("Updating EPG failed (no recovery).");
      const error = toError(err);
      if (error.name !== "AbortError") {
        player.panic(error);
      }
    });
  }
  get entries() {
    return this.events.entries;
  }
  destroy() {
    super.destroy();
    this.events.destroy();
  }
  async updateEPGLoop(psapiClient) {
    for await (const epg of psapiClient.loadEPG()) {
      if (epg.length === 0) {
        this._logger.log("No EPG available.");
        break;
      }
      this._logger.log("Updating EPG events.");
      await this.events.updateEPG(epg);
    }
    this._logger.log("EPG iterator ended.");
  }
}
export {
  EPGState
};
